package one.healthium.update_food_preferences.navigation

import androidx.compose.runtime.Composable
import androidx.compose.runtime.CompositionLocalProvider
import androidx.lifecycle.viewmodel.compose.LocalViewModelStoreOwner
import one.healthium.update_food_preferences.ui.UpdateFoodPreferencesScreen

@Composable
fun UpdateFoodPreferencesContent(component: UpdateFoodPreferencesComponent) {
    CompositionLocalProvider(LocalViewModelStoreOwner provides component) {
        UpdateFoodPreferencesScreen(component)
    }
}